import { HasPlantDateTracking } from '../../../models/plant-date-tracking';

export enum SprayAdvice {
  cropsProtected = 'CROPS_PROTECTED',
  preventive = 'PREVENTIVE',
  curative = 'CURATIVE',
  stop = 'STOP',
  noAdvice = 'NO_ADVICE',
}

export enum VirusSprayCategory {
  Systemic = 1,
  Pyrethroid = 2,
  Oil = 3,
}

export interface CropFieldAdvice {
  cropFieldId: number;
  cropFieldName: string;
  cropVarietyName?: string;
  cropYear: number;
  amountOfHectares: number;
  advices: DailyAdvice[];
  todaysAdvice?: DailyAdvice;
  lastSprayDate?: Date;
  plantDate?: Date;
  emergenceDate?: Date;
  harvestDate?: Date;
  isCropFieldVisible: boolean;
}

export interface DailyAdvice {
  date: Date;
  sprayAdvice?: SprayAdvice;
  remainingFungicidePercentage?: number;
  isSprayedToday?: boolean;
  translationKey?: string;
  stylingOverride?: { [key: string]: string } | null;
}

export interface AdviceMouseClickEvent {
  mouseEvent: MouseEvent;
  cropField: CropFieldAdvice;
}

export interface DayRange {
  daysInPast: number;
  daysInFuture: number;
}

export type DiseaseContext = 'blight' | 'downy-mildew' | 'virus-monitor';

export type BaseCropFieldRegistration = HasPlantDateTracking & {
  cropFieldId: number;
  year: number;
  plantDate: Date;
  emergenceDate: Date;
  harvestDate: Date;
  isPlantDateConfirmed: boolean;
  isParticipatingToBem?: boolean;
  externalCropFieldId?: string;
  feature?: string;
  created?: Date;
  updated?: Date;
};

export interface VirusMonitorCropFieldRegistration extends BaseCropFieldRegistration {
  deadFoliageDate?: Date;
  sprayThreshold?: number;
  availableProtectionTypes: VirusSprayCategory[];
  selectedProtectionTypes: VirusSprayCategory[];
}
